<div class="numeric">
  <div class="numeric__label">
    <ion-label>{{question.label}}</ion-label>
  </div>

  <div class="numeric-question__tip"
       *ngIf="question.tip">
    <ion-label class="numeric-question__tip">{{question.tip}}</ion-label>
  </div>

  <div class="numeric-input-group">

    <div class="numeric-question__amount">
      <span class="pound"
            *ngIf="value && isCurrency">&pound;</span>

      <input type="tel"
             class="form-control type_msg"
             [class.currency]="value && isCurrency"
             [class.has-error]="question.error"
             [class.is-invalid]="question.error"
             [maskito]="mask"
             [name]="question.key"
             [maxlength]="length"
             [placeholder]="placeholder"
             [(ngModel)]="value"
             (keyup.enter)="save()"
             (blur)="save()"
             (cdkAutofill)="save()"
             (ngModelChange)="question.error = null"
             (mouseout)="resetPlaceholder()"
             required
             #numeric="ngModel"
             #input/>

    </div>
  </div>
</div>
